/**
 * @name CoreBTC CRM 路由配置
 * @doc https://umijs.org/docs/guides/routes
 */
export default [
  {
    path: '/user',
    layout: false,
    routes: [
      {
        name: 'login',
        path: '/user/login',
        component: './user/login',
      },
    ],
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    icon: 'dashboard',
    access: 'canDashboard',
    component: './dashboard',
  },
  {
    path: '/users',
    name: 'users',
    icon: 'team',
    access: 'canUsers',
    routes: [
      {
        path: '/users',
        redirect: '/users/list',
      },
      {
        path: '/users/list',
        name: 'list',
        component: './users/list',
      },
      {
        path: '/users/deleted',
        name: 'deleted',
        component: './users/deleted',
      },
      {
        path: '/users/wallets',
        name: 'wallets',
        component: './users/wallets',
      },
      {
        path: '/users/:id',
        name: 'detail',
        component: './users/detail',
        hideInMenu: true,
      },
    ],
  },
  {
    path: '/miners',
    name: 'miners',
    icon: 'tool',
    access: 'canMiners',
    routes: [
      {
        path: '/miners',
        redirect: '/miners/products',
      },
      {
        path: '/miners/products',
        name: 'products',
        component: './miners/products',
      },
    ],
  },
  {
    path: '/orders',
    name: 'orders',
    icon: 'shoppingCart',
    access: 'canOrders',
    component: './orders',
  },
  {
    path: '/tickets',
    name: 'tickets',
    icon: 'tag',
    access: 'canTickets',
    routes: [
      {
        path: '/tickets',
        redirect: '/tickets/products',
      },
      {
        path: '/tickets/products',
        name: 'products',
        component: './tickets/products',
      },
    ],
  },
  {
    path: '/withdrawals',
    name: 'withdrawals',
    icon: 'transaction',
    access: 'canWithdrawals',
    routes: [
      {
        path: '/withdrawals',
        redirect: '/withdrawals/pending',
      },
      {
        path: '/withdrawals/pending',
        name: 'pending',
        component: './withdrawals/pending',
      },
      {
        path: '/withdrawals/history',
        name: 'history',
        component: './withdrawals/history',
      },
    ],
  },
  {
    path: '/activities',
    name: 'activities',
    icon: 'gift',
    access: 'canActivities',
    routes: [
      {
        path: '/activities',
        redirect: '/activities/daily-pool',
      },
      {
        path: '/activities/daily-pool',
        name: 'dailyPool',
        component: './activities/daily-pool',
      },
      {
        path: '/activities/social',
        name: 'social',
        component: './activities/social',
      },
      {
        path: '/activities/tasks',
        name: 'tasks',
        component: './activities/tasks',
      },
      {
        path: '/activities/promotions',
        name: 'promotions',
        component: './activities/promotions',
      },
    ],
  },
  {
    path: '/qa',
    name: 'qa',
    icon: 'questionCircle',
    access: 'canQa',
    component: './qa',
  },
  {
    path: '/analytics',
    name: 'analytics',
    icon: 'lineChart',
    access: 'canAnalytics',
    component: './analytics',
  },
  {
    path: '/channels',
    name: 'channels',
    icon: 'funnelPlot',
    access: 'canChannels',
    component: './channels',
  },
  {
    path: '/analytics-events',
    name: 'analyticsEvents',
    icon: 'thunderbolt',
    access: 'canAnalyticsEvents',
    component: './analytics-events',
  },
  {
    path: '/payments',
    name: 'payments',
    icon: 'dollarCircle',
    access: 'canPayments',
    routes: [
      {
        path: '/payments',
        redirect: '/payments/unmatched',
      },
      {
        path: '/payments/unmatched',
        name: 'unmatched',
        component: './payments/unmatched',
      },
      {
        path: '/payments/voided',
        name: 'voided',
        component: './payments/voided',
      },
    ],
  },
  {
    path: '/reconciliation',
    name: 'reconciliation',
    icon: 'audit',
    access: 'canReconciliation',
    component: './reconciliation',
  },
  {
    path: '/transactions',
    name: 'transactions',
    icon: 'unorderedList',
    access: 'canTransactions',
    component: './transactions',
  },
  {
    path: '/settings',
    name: 'settings',
    icon: 'setting',
    access: 'canSettings',
    component: './settings',
  },
  {
    path: '/messages',
    name: 'messages',
    icon: 'message',
    access: 'canMessages',
    routes: [
      {
        path: '/messages',
        redirect: '/messages/list',
      },
      {
        path: '/messages/list',
        name: 'list',
        component: './messages/list',
      },
      {
        path: '/messages/send',
        name: 'send',
        access: 'canMessagesSend',
        component: './messages/send',
      },
    ],
  },
  {
    path: '/system',
    name: 'system',
    icon: 'safety',
    routes: [
      {
        path: '/system',
        redirect: '/system/accounts',
      },
      {
        path: '/system/accounts',
        name: 'accounts',
        access: 'canSystemAccounts',
        component: './system/accounts',
      },
      {
        path: '/system/roles',
        name: 'roles',
        access: 'canSystemRoles',
        component: './system/roles',
      },
    ],
  },
  {
    path: '/',
    redirect: '/dashboard',
  },
  {
    path: '*',
    layout: false,
    component: './404',
  },
];
